import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CustomTableFilters',
  emits: ['reset', 'submit'],
  setup(__props, { emit }) {



const { t } = useI18n();

return { __sfc: true,emit, t }
}

})